import React from 'react'
import { Input as UiKitInput, InputProps } from '@elamajs/ui-kit'

import * as Styled from './Input.styled'

type Props = {
  as?: React.ElementType
} & InputProps

const Input: React.FC<Props> = ({ as = UiKitInput, ...props }) => {
  return (
    <Styled.Container>
      <Styled.Input as={as} {...props} />
    </Styled.Container>
  )
}

export default Input
